import api from "./Api";

class RestauranteMotoristaService {
  GetRestauranteMotorista(payload) {
    return api
      .get("/v1/RestauranteMotorista/" + payload)
      .then((response) => response.data);
  }

  PostRestauranteMotorista(payload) {
    return api
      .post("/v1/RestauranteMotorista/", payload)
      .then((response) => response.data);
  }

  PutRestauranteMotorista(payload) {
    return api
      .put("/v1/RestauranteMotorista/", payload)
      .then((response) => response.data);
  }

  DeleteRestauranteMotorista(payload) {
    return api
      .delete("/v1/RestauranteMotorista/" + payload)
      .then((response) => response.data);
  }

  GetRestauranteMotoristaOData(payload) {
    return api
      .get("/OData/RestauranteMotorista" + payload)
      .then((response) => response.data);
  }
}

export default new RestauranteMotoristaService();
